/* eslint-disable */
import qualityAnalyticsServices from '@/Services/Analytics Services/qualityAnalytics.services';
import { useQualityAnalysisStore } from '../QualityAnalysisStore';
import masterMenuServices from '@/Services/ProductSpecificationParamServices/productMasterMenu.services';
import {
	getAnalysisType,
	getGroupingType,
	handleAddTimeFrame,
	metricsToCardData,
	parseDefaultStatisticalAnalysisData,
} from './filterDeserializer';
import { notificationServices } from '@/Services';
import moment from 'moment';
import fetchStatisticalAnalysisGraph, { statisticalGateways } from '@/Services/Analytics Services/statisticalAnalysisServices';
import { handleResponseStreamDownload } from '@/Helpers';
import { initialAnalysisTabs, initialTabs, machineParameters, timeFrameList } from '../tempData';
// Initialize listeners for state changes

const parseUrlParams = () => {
	const params = new URLSearchParams(window.location.search);
	const result = {};

	for (const [key, value] of params.entries()) {
		try {
			result[key] = JSON.parse(value);
		} catch {
			result[key] = value;
		}
	}

	return result;
};

const waitForProductList = (maxWaitMs = 10000, pollIntervalMs = 100) => {
	return new Promise((resolve) => {
		const state = useQualityAnalysisStore.getState();
		// Check if already available
		if (state?.globalProductList?.length > 0) {
			resolve(true);
			return;
		}
		notificationServices.generateNotification({
			type: 'info',
			message: 'Waiting for products list to load...',
		});
		const startTime = Date.now();
		const checkProductList = () => {
			const currentState = useQualityAnalysisStore.getState();
			if (currentState?.globalProductList?.length > 0) {
				notificationServices.generateNotification({
					type: 'success',
					message: 'Products list loaded successfully',
				});
				resolve(true);
				return;
			}
			if (Date.now() - startTime >= maxWaitMs) {
				console.warn('Timeout waiting for globalProductList');
				notificationServices.generateNotification({
					type: 'error',
					message: 'Timeout waiting for products list',
				});
				resolve(false);
				return;
			}
			setTimeout(checkProductList, pollIntervalMs);
		};
		checkProductList();
	});
};

const syncFromUrl = async () => {
	const parsedParams = parseUrlParams();
	const state = useQualityAnalysisStore.getState();
	const { setActiveTab, setActiveAnalysisTab, setExtraButtonInfo, setIsUrlInitialized } = state;

	// Handle the new 'selections' parameter format
	if (parsedParams.selections) {
		const selections = parsedParams.selections;

		// Mark that we're initializing from URL - skip default data calls
		setIsUrlInitialized(true);

		// Set main tab if provided
		if (selections.tab) {
			setActiveTab(selections.tab);
		}

		// Set analysis tab if provided
		if (selections.analysisTab) {
			setActiveAnalysisTab(selections.analysisTab);
		}

		// Set extra button info if provided
		if (selections.extraButtonInfo) {
			setExtraButtonInfo(selections.extraButtonInfo);
		}

		// Handle statistical analysis specific state
		if (selections.analysisTab === 'statistical') {
			// Wait for products list to be available
			await waitForProductList();

			const currentState = useQualityAnalysisStore.getState();

			// Set quality parameter (e.g., 'weight')
			if (selections.selectedQualityParameter) {
				currentState.setSuppressNotification(true);
				currentState.setSelectedQualityAnalysisParameter(selections.selectedQualityParameter);
			}

			// Build product selection ID based on productId and variantId
			if (selections.productId && selections.variantId) {
				const productVariantId = `${selections.productId}-${selections.variantId}`;
				currentState.setSelectedQualityParameterProduct(productVariantId);
			}

			// Set time frame to 'Custom' for date ranges
			if (selections.dateRanges && selections.dateRanges.length > 0) {
				currentState.setTimeFrame('Custom');

				// Build filtered product list for the selected product
				const filteredProductList = [];
				currentState.globalProductList?.forEach((product) => {
					product.variants
						?.filter((variant) => variant.id === Number(selections.variantId))
						.forEach((variant) => {
							filteredProductList.push({
								id: `${product.id}-${variant.id}`,
								productName: `${product.productName} (${variant.displayName})`,
								title: `${product.productName} (${variant.displayName})`,
								imageUrl: product.productImageUrl,
							});
						});
				});

				// Add date ranges as time frame cards
				selections.dateRanges.forEach((dateRange, idx) => {
					const startDate = moment(dateRange.from).toDate();
					const endDate = moment(dateRange.to).toDate();
					const isLast = idx === selections.dateRanges.length - 1;
					handleAddTimeFrame(
						filteredProductList,
						isLast, // only apply when it's the last one
						'Custom',
						filteredProductList?.[0]?.id,
						startDate,
						endDate,
						dateRange.userSelected || false
					);
				});
			}

			currentState.setSuppressNotification(false);
		}

		return;
	}

	// Legacy support for simple tab/analysisTab params
	if (parsedParams.tab) {
		setActiveTab(parsedParams.tab);
	}

	if (parsedParams.analysisTab) {
		setActiveAnalysisTab(parsedParams.analysisTab);
	}
};

const statsSerilizer = (data) => {
	const info = data[0];
	const newData = Object.keys(info).map((current) => {
		return {
			label: current,
			value: info[current],
			icon:
				current === 'total'
					? 'ClipboardList'
					: current === 'passed'
						? 'CircleCheck'
						: current === 'pass_percent'
							? 'percent'
							: '',
		};
	});
	return newData;
};

const fetchStatisticalAnalysis = async (builtFilters) => {
	const state = useQualityAnalysisStore.getState();
	const addedCardData = state?.cardData;
	if (addedCardData.length === 0 && !builtFilters?.export) {
		return;
	}
	const groupDateRanges = {};
	let dateRangeFilter = {};

	addedCardData?.forEach?.((item, index) => {
		if (index < addedCardData?.length) {
			const key = item?.id;
			if (Array.isArray(item?.timeFrame?.value)) {
				groupDateRanges[key] = {
					start: moment(item?.timeFrame?.value[0]).format(
						'YYYY-MM-DD'
					),
					end: moment(item?.timeFrame?.value[1]).format('YYYY-MM-DD'),
				};
			} else if (typeof item?.timeFrame?.value === 'object') {
				groupDateRanges[key] = {
					start: moment(item?.timeFrame?.value).format('YYYY-MM-DD'),
					end: moment(item?.timeFrame?.value).format('YYYY-MM-DD'),
				};
			}
		}
	});

	if (state?.dateRangeExport && builtFilters?.export) {
		dateRangeFilter = {
			dateRangeFilter: {
				from: state?.dateRangeExport?.date?.from,
				to: state?.dateRangeExport?.date?.to,
			},
		};
	}

	const req = {
		data: {
			...builtFilters,
			groupDateRanges,
			...dateRangeFilter,
		},
	};
	try {
		let response = {};
		if (state?.activeTab === 'sourcing') {
			response =
				await qualityAnalyticsServices.fetchQualityAnalysisChartData({
					req,
				});
		} else if (state?.activeTab === 'production') {
			if (builtFilters?.export) {
				response = await statisticalGateways.exportStatisticalAnalysis({
					req,
				});
				const exportFileName = `All_Products_Avg_${state?.dateRangeExport?.date?.from}_${state?.dateRangeExport?.date?.to}.csv`;
				handleResponseStreamDownload(response, exportFileName);
			} else {
				response = await fetchStatisticalAnalysisGraph({
					req,
				});
			}
		}
		if (builtFilters?.export) {
			notificationServices.generateNotification({
				type: 'success',
				message: 'Exported successfully',
			});
			return;
		}
		if (response?.statusCode === 200) {
			const { data } = response;
			if (data?.boxData?.length > 0) {
				state?.setStatisticalAnalysisData({
					statsBoxData: statsSerilizer(data?.boxData) || [],
					lineData: data?.graphData,
					metricData: data?.metrics,
				});
				metricsToCardData(data?.metrics, state?.setCardData);
			} else {
				notificationServices.generateNotification({
					type: 'error',
					message:
						response?.errorMessage ||
						'No data found for selected product and time frame',
				});
			}
		} else {
			notificationServices.generateNotification({
				type: 'error',
				message:
					response?.errorMessage ||
					'No data found for selected product and time frame',
			});
		}
	} catch (error) {
		notificationServices.generateNotification({
			type: 'error',
			message: error?.toString() || 'Error fetching bar data',
		});
	}
};

const fetchInitialData = async () => {
	const state = useQualityAnalysisStore.getState();
	state.setLoading(true);

	// Wait for products list to be available first
	await waitForProductList();

	// Check if we're initializing from URL - if so, skip the default data fetch
	const currentState = useQualityAnalysisStore.getState();
	if (currentState.isUrlInitialized) {
		// Only fetch the menu data, not the chart data
		const menuResponse = await masterMenuServices.productMasterMenuList();
		if (menuResponse?.statusCode === 200) {
			const data = menuResponse?.data;
			const newData = data
				.map((item) => ({
					key: item?.id,
					label: item?.name,
					inputType: item?.inputType,
				}))
				?.filter((item) => ['number', 'decimal'].includes(item?.inputType));
			currentState.setQualityAnalysisParameters(newData);
		}
		currentState.setLoading(false);
		return;
	}

	// Fetch both data sources simultaneously (normal flow)
	const [dataResponse, menuResponse] = await Promise.all([
		fetchAppropriateData(),
		masterMenuServices.productMasterMenuList(),
	]);
	const response = menuResponse; // Maintain the response variable for the following code
	if (response?.statusCode === 200) {
		const data = response?.data;
		const newData = data
			.map((item) => ({
				key: item?.id,
				label: item?.name,
				inputType: item?.inputType,
			}))
			?.filter((item) => ['number', 'decimal'].includes(item?.inputType));
		state.setQualityAnalysisParameters(newData);
	} else {
		notificationServices.generateNotification({
			type: 'error',
			message: response?.message || 'Error fetching Quality master menu',
		});
	}
	state.setLoading(false);
};

const setInitialQualityParameter = async () => {
	const state = useQualityAnalysisStore.getState();
	const firstQualityParameter = state?.qualityAnalysisParameters[0];
	state.setSelectedQualityAnalysisParameter(firstQualityParameter?.key);
};

const handleStatisticalProductSelection = async () => {
	const state = useQualityAnalysisStore.getState();
	const selectedQualityAnalysisParameter =
		state?.selectedQualityAnalysisParameter;
	const req = {
		data: {
			qualityParameterId: selectedQualityAnalysisParameter,
		},
	};
	const response =
		await qualityAnalyticsServices.fetchParameterProductsStatisticalAnalysis(
			{ req }
		);
	if (response?.statusCode === 200) {
		state.setQualityParameterProducts(response?.data?.productIds ?? []);
	} else {
		notificationServices.generateNotification({
			type: 'error',
			message: response?.message || 'Error fetching parameter products',
		});
	}
};

const initializeStateChangeListeners = () => {
	fetchInitialData();
	const unSubs = [];
	changeEventOnKeys.forEach((key) => {
		const unSub = useQualityAnalysisStore.subscribe(
			(state) => state[key],
			(current, previous) => {
				keyChangeFunction(key, current, previous);
			}
		);
		unSubs.push(unSub);
	});
	return () => unSubs.forEach((unSub) => unSub());
};

// Function to fetch appropriate data based on active analysis tab
const fetchAppropriateData = async ({ exportButtonClicked = false, filterApplied = false } = {}) => {


	const state = useQualityAnalysisStore.getState();
	const activeAnalysisTab = state?.activeAnalysisTab;
	const activeTab = state?.activeTab;
	try {
		const filters = buildFiltersFromState();
		state?.setLoading(true);
		switch (activeAnalysisTab) {
			case 'quality':
			case 'failure':
				let response = {};
				if (activeTab === 'sourcing') {
					response =
						await qualityAnalyticsServices.fetchQualityAnalysisChartData(
							{ req: { data: filters } }
						);
				} else if (activeTab === 'production') {
					response =
						await qualityAnalyticsServices.fetchQualityAnalysisGraph(
							{
								req: {
									data: { failureAnalysis: {}, ...filters },
								},
							}
						);
				} else if (activeTab === 'distribution') {
					// response =
					// 	await qualityAnalyticsServices.fetchQualityAnalysisList(
					// 		{ req: { data: filters } }
					// 	);
				}

				if (response?.statusCode === 200) {
					state?.setQualityAnalysisChartData(response?.data);
				}
				break;
			case 'statistical':
				fetchStatisticalAnalysis({ ...filters, export: exportButtonClicked });
				break;
			default:
				console.warn(`Unknown analysis tab: ${activeAnalysisTab}`);
		}
	} catch (error) {
		console.error(`Error fetching data for ${activeAnalysisTab}:`, error);
	} finally {
		state?.setLoading(false);
	}
};

const buildFiltersFromState = () => {
	const state = useQualityAnalysisStore.getState();

	const analysisTypeObjFilters = getAnalysisType(
		state?.activeAnalysisTab,
		state
	);
	const dateRangeAndGrouping = getGroupingType(
		state?.activeConfigType,
		state
	);
	const grouping = {};
	if (state?.activeAnalysisTab) {
		grouping.active = true;
	}

	// Extract date details from dateInfo
	const filterState = {
		...dateRangeAndGrouping,
		...analysisTypeObjFilters,
	};

	// Add ImagesFinder filters for statistical analysis
	if (state?.activeAnalysisTab === 'statistical') {
		const { imagesFinderFilters } = state;

		// Add storeIds if available
		if (imagesFinderFilters?.store?.id > 0) {
			filterState.storeFilter = [imagesFinderFilters?.store?.id];
		}

		// You can add more filters from imagesFinderFilters here as needed
		// For example: vendorIds, productIds, etc.
	}

	return filterState;
};

const changeEventOnKeys = [
	'activeTab',
	'activeAnalysisTab',
	'activeQCType',
	'activeConfigType',
	'activeTimeRangeDropdown',
	'dateRangeObj',
	'dateInfo',
	'selectedQualityAnalysisParameter',
	'selectedQualityParameterProduct',
	'activeProductWiseDropdown',
	'activeGeographyWiseDropdown',
	'triggerChartUpdateApiCall',
	'triggerExportApiCall',
	'triggerFilterApply', // Trigger API call when filters are applied
	// 'cardData',
];

const keyChangeFunction = (key, current, previous) => {
	// console.log(`${key} changed: `, current, ` (previous: `, previous, ')');
	// because activeTimeRangeDropdown useEffect causes dateInfo to be changed
	const exportButtonClicked = (key === 'triggerExportApiCall' && current !== previous) ? true : false;
	const filterApplied = (key === 'triggerFilterApply' && current !== previous) ? true : false;
	const state = useQualityAnalysisStore.getState();
	if (key === 'selectedQualityParameterProduct') {
		if (!current) {
			return;
		}
	}
	if (
		key === 'selectedQualityAnalysisParameter' &&
		state?.activeAnalysisTab === 'statistical' &&
		!['temperature', 'weight'].includes(current)
	) {
		handleStatisticalProductSelection();
		return;
	}
	if (
		key === 'activeAnalysisTab' &&
		state?.activeAnalysisTab === 'statistical'
	) {
		setInitialQualityParameter();
		return;
	}
	if (key === 'activeTimeRangeDropdown') {
		return;
	}
	// console.log('exportButtonClicked', exportButtonClicked);
	fetchAppropriateData({ exportButtonClicked, filterApplied });
};

const fetchDefaultData = async (justClickedAnalysisTab) => {
	const state = useQualityAnalysisStore.getState();
	const activeAnalysisTab = justClickedAnalysisTab ?? state?.activeAnalysisTab;
	const activeTab = state?.activeTab;
	try {
		state?.setLoading(true);
		switch (activeAnalysisTab) {
			case 'quality':
			case 'failure':
				break;
			case 'statistical':
				const response = await qualityAnalyticsServices.fetchQualityAnalysisDefaultData(
					{
						req: {
							data: {
								statisticalPossibleData: true
							},
						},
					}
				);
				const parsedData = parseDefaultStatisticalAnalysisData(response?.data?.variantBasedWeekGrouping);
				handleDefaultStatisticalAnalysisDataSet(parsedData, Object.keys(parsedData)?.[0]);
				// fetchStatisticalAnalysis({...filters, export: exportButtonClicked});
				break;
			default:
				console.warn(`Unknown analysis tab: ${activeAnalysisTab}`);
		}
	} catch (error) {
		console.error(`Error fetching data for ${activeAnalysisTab}:`, error);
	} finally {
		state?.setLoading(false);
	}
};

const handleDefaultStatisticalAnalysisDataSet = (defaultData, defaultKey = null) => {
	const state = useQualityAnalysisStore.getState();
	state?.setSuppressNotification(true);
	state?.setSelectedQualityAnalysisParameter(machineParameters?.[1]?.key);
	let key = defaultKey;
	if (!key) {
		key = Object.keys(defaultData)?.[0];
	}
	const timeFrame = timeFrameList[1];
	const variantId = key;

	const dateRanges = defaultData?.[variantId]?.slice(0, 4) || [];
	const filteredProductList = [];
	state?.globalProductList?.forEach((product) => {
		product.variants
			?.filter((variant) => variant.id === Number(variantId))
			.forEach((variant) => {
				filteredProductList.push({
					id: `${product.id}-${variant.id}`,
					productName: `${product.productName} (${variant.displayName})`,
					title: `${product.productName} (${variant.displayName})`,
					imageUrl: product.productImageUrl,
				});
			});
	});
	state?.setSelectedQualityParameterProduct(filteredProductList?.[0]?.id);
	state?.setTimeFrame(timeFrame);
	dateRanges.forEach((dateRange, idx) => {
		const startDate = moment(dateRange.from).toDate();
		const endDate = moment(dateRange.to).toDate();
		const isLast = idx === dateRanges.length - 1;
		handleAddTimeFrame(
			filteredProductList,
			isLast, // only apply when it's the last one
			timeFrame,
			filteredProductList?.[0]?.id,
			startDate,
			endDate
		);
	});
	state?.setSuppressNotification(false);
}

const handleDefaultDataSet = async (currentAnalysisTab) => {
	const state = useQualityAnalysisStore.getState();

	// Skip default data set if state was initialized from URL
	if (state?.isUrlInitialized) {
		return;
	}

	if (state?.activeTab !== initialTabs?.[1]?.key) {
		return;
	}
	switch (currentAnalysisTab) {
		case initialAnalysisTabs?.[2]?.key:
			// Wait for products list to be fetched before applying default state
			await waitForProductList();
			fetchDefaultData(currentAnalysisTab);
			break;
		default:
			break;
	}
};

export { initializeStateChangeListeners, keyChangeFunction, handleDefaultDataSet, syncFromUrl };

